export type QueueItClubConfiguration = Readonly<{
  customerId: string;
  nativeWaitingRoomAlias: string | null;
}>;

export type QueueItPlatform = "native" | "web";

export type QueueItClubConfig = Readonly<{
  customerId: string;
  eventAlias: string | null;
}>;

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.trim().length > 0;

/**
 * LaunchDarkly only enables the queue for a targeted club and platform. The
 * Queue-it customer and native waiting-room alias live with the club's app
 * configuration, so they are not duplicated in a feature-flag variation.
 */
export const getQueueItClubConfig = (
  value: unknown,
  clubConfiguration: QueueItClubConfiguration | null,
  platform: QueueItPlatform
): QueueItClubConfig | null => {
  if (value !== true || !clubConfiguration) {
    return null;
  }

  if (!isNonEmptyString(clubConfiguration.customerId)) {
    return null;
  }

  if (
    platform === "native" &&
    !isNonEmptyString(clubConfiguration.nativeWaitingRoomAlias)
  ) {
    return null;
  }

  return {
    customerId: clubConfiguration.customerId,
    eventAlias:
      platform === "native" ? clubConfiguration.nativeWaitingRoomAlias : null,
  };
};
